var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section-login" },
    [
      _vm.registerFrom === "registerPage"
        ? [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "button-large button-block button-login -indigo",
                    on: {
                      click: function($event) {
                        return _vm.preLogin("facebook")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-facebook-f" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("message.register.register_with_facebook")
                        )
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-large button-block button-login -red",
                    on: {
                      click: function($event) {
                        return _vm.preLogin("googleplus")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-google" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(
                        _vm._s(_vm.$t("message.register.register_with_google"))
                      )
                    ])
                  ]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-3" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "button-large button-block button-login",
                    on: {
                      click: function($event) {
                        return _vm.preLogin("apple")
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fab fa-apple" }),
                    _vm._v("   "),
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("message.login.login_with_apple")))
                    ])
                  ]
                )
              ])
            ])
          ]
        : _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("message.login.sign_up_with")) +
                  "\n      "
              ),
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.preLogin("facebook")
                    }
                  }
                },
                [_vm._v("Facebook")]
              ),
              _vm._v(", "),
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.preLogin("googleplus")
                    }
                  }
                },
                [_vm._v("Google")]
              ),
              _vm._v(
                "\n      " + _vm._s(_vm.$t("message.login.or")) + "\n      "
              ),
              _c(
                "a",
                {
                  attrs: { href: "" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.preLogin("apple")
                    }
                  }
                },
                [_vm._v("Apple")]
              )
            ])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "background my-3" }, [
        _c("span", [_vm._v(_vm._s(_vm.$t("message.login.or")))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 text-left" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userData.email,
                  expression: "userData.email"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorEmail },
              attrs: {
                type: "email",
                placeholder: _vm.$t("message.login.email")
              },
              domProps: { value: _vm.userData.email },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userData, "email", $event.target.value)
                  },
                  function($event) {
                    return _vm.updateFormData("email", $event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorEmail
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(_vm._s(_vm.errorEmailText) + "\n        ")
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userData.firstname,
                  expression: "userData.firstname"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorFirstName },
              attrs: {
                type: "text",
                placeholder: _vm.$t("message.login.firstname")
              },
              domProps: { value: _vm.userData.firstname },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userData, "firstname", $event.target.value)
                  },
                  function($event) {
                    return _vm.updateFormData("firstname", $event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorFirstName
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("message.login.firstname_is_required")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userData.lastname,
                  expression: "userData.lastname"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorLastName },
              attrs: {
                type: "email",
                placeholder: _vm.$t("message.login.lastname")
              },
              domProps: { value: _vm.userData.lastname },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userData, "lastname", $event.target.value)
                  },
                  function($event) {
                    return _vm.updateFormData("lastname", $event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorLastName
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.login.lastname_is_required")) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userData.password,
                  expression: "userData.password"
                }
              ],
              staticClass: "form-control input-lg",
              class: { "form-alert": _vm.errorPassword },
              attrs: {
                type: "password",
                maxlength: "20",
                placeholder: _vm.$t("message.login.password")
              },
              domProps: { value: _vm.userData.password },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.userData, "password", $event.target.value)
                  },
                  function($event) {
                    return _vm.updateFormData("password", $event)
                  }
                ]
              }
            }),
            _vm._v(" "),
            _vm.errorPassword
              ? _c("div", { staticClass: "form-alert-text -status-alert" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.errorPasswordText) +
                      "\n        "
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "accept-term-text" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.login.clicking_sign_up")) +
                  "\n          "
              ),
              _c("a", { attrs: { href: "/term", target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("message.footer.terms_and_conditions")))
              ]),
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("message.login.and")) +
                  "\n          "
              ),
              _c("a", { attrs: { href: "/privacy", target: "_blank" } }, [
                _vm._v(_vm._s(_vm.$t("message.footer.privacy_policy")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button-large button-block -cyan",
                attrs: { disabled: _vm.state.isRegistering },
                on: { click: _vm.performRegister }
              },
              [_c("label", [_vm._v(_vm._s(_vm.$t(_vm.isRegistering)))])]
            )
          ])
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0104569d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0104569d","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/RegisterForm.vue
// module id = 1445
// module chunks = 0